import { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote: 'Después del incendio en nuestra cocina, no sabíamos por dónde empezar. FIRETRAUMAS coordinó todo con el seguro y dejó el piso impecable.',
      name: 'Marta R.',
      location: 'Gràcia'
    },
    {
      quote: (
        <>
          Rápidos, <a href="https://ajuntament.barcelona.cat/bombers/es" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors underline">profesionales y muy atentos</a>. El olor a humo desapareció por completo. Recomiendo sus servicios sin dudarlo.
        </>
      ),
      name: 'Jordi T.',
      location: 'Eixample'
    },
    {
      quote: 'Nos explicaron cada paso del proceso. Recuperamos objetos que creíamos perdidos. Un trato excepcional en un momento muy difícil.',
      name: 'Ana S.',
      location: 'Sarrià'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-primary mb-6">
            Qué dicen nuestros clientes
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 px-2 sm:px-4">
                  <div className="bg-bg rounded-lg p-6 sm:p-8 md:p-12">
                    <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8">
                      {/* Quote */}
                      <div className="flex-1">
                        <i className="ri-double-quotes-l text-4xl sm:text-5xl text-secondary/30 mb-4"></i>
                        <p className="font-serif text-xl sm:text-2xl md:text-3xl text-primary leading-relaxed mb-6 break-words">
                          {testimonial.quote}
                        </p>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                          <div>
                            <p className="font-sans font-bold text-primary">{testimonial.name}</p>
                            <p className="text-textLight text-sm">{testimonial.location}</p>
                          </div>
                          <span className="bg-accent/20 text-accent text-xs px-3 py-1 rounded-full font-semibold whitespace-nowrap">
                            ✓ Cliente verificado
                          </span>
                        </div>
                      </div>

                      {/* Avatar */}
                      <div className="flex-shrink-0">
                        <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-secondary/10 flex items-center justify-center">
                          <i className="ri-user-line text-4xl sm:text-5xl text-secondary"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  currentSlide === index ? 'bg-secondary w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}